import { Link } from "react-router-dom";
import { ArrowRight, Boxes, Layers, LayoutGrid, MoveHorizontal, Package, PackageOpen } from "lucide-react";
import { SEO } from "../components/SEO";
import { QuoteCTA } from "../components/CTA";
import { NEEDS } from "../data/site";

const ICONS = { Package, PackageOpen, Boxes, MoveHorizontal, LayoutGrid, Layers };

export default function Solutions() {
  return (
    <>
      <SEO title="Storage Solutions by Requirement | CustoRacks"
        description="Not sure which storage system you need? Tell us what you're storing — palletised goods, cartons, small components, long materials — and we'll identify a suitable storage solution." />
      <section className="page-hero" data-testid="solutions-hero">
        <div className="container">
          <div className="crumbs">Home / Solutions</div>
          <h1>Not Sure Which Storage System You Need?</h1>
          <p>Tell us what you're storing. We'll help you identify a suitable storage solution.</p>
        </div>
      </section>
      <section className="section">
        <div className="container">
          <div className="grid-3">
            {NEEDS.map((n) => {
              const Icon = ICONS[n.icon];
              return (
                <Link to={`/products/${n.slug}`} className="need-card" key={n.need} data-testid={`solution-${n.slug}`}>
                  <Icon size={30} />
                  <h3>{n.need}</h3>
                  <div className="need-rec">
                    <small>Recommended</small>
                    <span>{n.rec} <ArrowRight size={14} /></span>
                  </div>
                </Link>
              );
            })}
          </div>
          <div className="needs-cta">
            <Link to="/contact" className="btn btn-orange" data-testid="solutions-talk-btn">Discuss Your Requirement <ArrowRight size={15} /></Link>
          </div>
        </div>
      </section>
      <QuoteCTA />
    </>
  );
}
